export interface VideoItem {
  id: string;
  title: string;
  cover: string;
  category: string;
  categorySlug: string;
  type: string;
  region: string;
  year: number;
  duration: string;
  rating: number;
  views: string;
  author: string;
  uploadDate: string;
  updateStatus: string;
  tags: string[];
  description: string;
  highlights: string[];
}

export const videoItems: VideoItem[] = [
  {
    id: '1001',
    title: '星海旅途',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20traveler%20standing%20before%20a%20vast%20glowing%20nebula%2C%20soft%20peach%20and%20warm%20amber%20light%20grading%2C%20artistic%20abstract%20space%20composition%2C%20high%20detail%20editorial%20quality&width=800&height=450&seq=mvita-cover-1001&orientation=landscape',
    category: '影视',
    categorySlug: 'movie',
    type: '科幻',
    region: '华语',
    year: 2024,
    duration: '02:15:40',
    rating: 8.9,
    views: '1,284万',
    author: '星野影像工作室',
    uploadDate: '2024-09-12',
    updateStatus: '已完结',
    tags: ['科幻', '冒险', '年度推荐'],
    description: '一支探索队在银河边缘发现未知信号，由此展开跨越星系的漫长旅途。影片以温暖的光影描绘人类对未知的向往与孤独。',
    highlights: ['星际场景长镜头设计', '原创交响配乐', '开放式结局引发讨论'],
  },
  {
    id: '1002',
    title: '都市夜行者',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20noir%20city%20poster%20with%20neon%20reflections%20on%20wet%20street%20at%20night%2C%20warm%20peach%20rim%20light%20against%20deep%20charcoal%20shadows%2C%20moody%20urban%20atmosphere%2C%20editorial%20film%20quality&width=800&height=450&seq=mvita-cover-1002&orientation=landscape',
    category: '影视',
    categorySlug: 'movie',
    type: '悬疑',
    region: '华语',
    year: 2024,
    duration: '01:48:20',
    rating: 8.4,
    views: '968万',
    author: '暗光电影',
    uploadDate: '2024-08-30',
    updateStatus: '已完结',
    tags: ['悬疑', '犯罪', '高分'],
    description: '霓虹未熄的深夜，一名记者追查连环旧案，城市的另一面在雨水中缓缓浮现。',
    highlights: ['非线性叙事结构', '雨夜长镜头', '反转结局'],
  },
  {
    id: '1003',
    title: '山野食光',
    cover: 'https://readdy.ai/api/search-image?query=warm%20rustic%20food%20documentary%20scene%20with%20fresh%20ingredients%20on%20a%20wooden%20table%20in%20soft%20morning%20light%2C%20peach%20and%20beige%20tones%2C%20cozy%20natural%20editorial%20photography&width=800&height=450&seq=mvita-cover-1003&orientation=landscape',
    category: '短视频',
    categorySlug: 'short',
    type: '美食',
    region: '华语',
    year: 2024,
    duration: '08:40',
    rating: 9.1,
    views: '2,310万',
    author: '慢煮生活',
    uploadDate: '2024-09-25',
    updateStatus: '更新至 36 集',
    tags: ['美食', '治愈', '生活'],
    description: '走进山野与灶台之间，用一餐一饭记录季节的变化与生活最本真的滋味。',
    highlights: ['4K 自然光拍摄', '原声环境音', '家常菜谱分享'],
  },
  {
    id: '1004',
    title: '晨跑日记',
    cover: 'https://readdy.ai/api/search-image?query=minimalist%20short%20video%20cover%20of%20a%20jogger%20silhouette%20on%20a%20misty%20city%20bridge%20at%20sunrise%2C%20soft%20peach%20sky%20gradient%2C%20clean%20airy%20composition%2C%20lifestyle%20editorial%20photography&width=800&height=450&seq=mvita-cover-1004&orientation=landscape',
    category: '短视频',
    categorySlug: 'short',
    type: '运动',
    region: '华语',
    year: 2024,
    duration: '05:12',
    rating: 8.6,
    views: '1,120万',
    author: '晨间频道',
    uploadDate: '2024-09-18',
    updateStatus: '更新至 52 集',
    tags: ['运动', '生活', '自律'],
    description: '365 天不间断的晨跑记录，用脚步丈量城市苏醒的每一个清晨。',
    highlights: ['第一视角拍摄', '配速数据可视化', '坚持打卡挑战'],
  },
  {
    id: '1005',
    title: '城市光影录',
    cover: 'https://readdy.ai/api/search-image?query=artistic%20urban%20photography%20poster%20with%20layered%20glass%20buildings%20reflecting%20golden%20hour%20light%2C%20peach%20and%20grey%20palette%2C%20abstract%20geometric%20composition%2C%20editorial%20quality&width=800&height=450&seq=mvita-cover-1005&orientation=landscape',
    category: '影视',
    categorySlug: 'movie',
    type: '剧情',
    region: '华语',
    year: 2023,
    duration: '01:32:10',
    rating: 8.2,
    views: '742万',
    author: '光年影业',
    uploadDate: '2024-07-06',
    updateStatus: '已完结',
    tags: ['剧情', '文艺', '口碑'],
    description: '三个陌生的都市人在同一栋写字楼里交错，光影之间藏着各自的秘密与温柔。',
    highlights: ['静帧美学', '群像叙事', '城市声音设计'],
  },
  {
    id: '1006',
    title: '极地远征',
    cover: 'https://readdy.ai/api/search-image?query=epic%20documentary%20poster%20of%20a%20vast%20ice%20field%20with%20a%20tiny%20explorer%20figure%2C%20soft%20peach%20low%20sun%20over%20glacier%2C%20minimal%20wide%20landscape%20composition%2C%20high%20detail%20nature%20photography&width=800&height=450&seq=mvita-cover-1006&orientation=landscape',
    category: '影视',
    categorySlug: 'movie',
    type: '纪录片',
    region: '欧美',
    year: 2024,
    duration: '00:58:30',
    rating: 9.3,
    views: '1,560万',
    author: '地球视角',
    uploadDate: '2024-09-01',
    updateStatus: '全 4 集',
    tags: ['纪录片', '自然', '高分'],
    description: '跟随科考队深入极地，记录冰川消融与极夜之下生命顽强的奇迹。',
    highlights: ['航拍冰川全景', '极夜星空延时', '科考第一现场'],
  },
  {
    id: '1007',
    title: '甜梦电台',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20live%20music%20session%20cover%20with%20warm%20amber%20stage%20lights%20and%20a%20vintage%20microphone%2C%20soft%20peach%20haze%20in%20the%20background%2C%20intimate%20club%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=mvita-cover-1007&orientation=landscape',
    category: '直播专区',
    categorySlug: 'live',
    type: '音乐',
    region: '华语',
    year: 2024,
    duration: '直播中',
    rating: 8.8,
    views: '3,420人观看',
    author: '甜梦电台',
    uploadDate: '2024-10-12',
    updateStatus: '每晚 20:00 开播',
    tags: ['音乐', '直播', '电台'],
    description: '一个只放好歌的深夜电台，主播用音乐和故事陪伴每一个还没入睡的人。',
    highlights: ['实时点歌互动', '深夜故事分享', '无损音质直播'],
  },
  {
    id: '1008',
    title: '匠心手作',
    cover: 'https://readdy.ai/api/search-image?query=craftsmanship%20short%20film%20cover%20with%20hands%20shaping%20clay%20on%20a%20potter%20wheel%2C%20warm%20peach%20window%20light%2C%20minimal%20workshop%20background%2C%20editorial%20artisan%20photography&width=800&height=450&seq=mvita-cover-1008&orientation=landscape',
    category: '短视频',
    categorySlug: 'short',
    type: '纪录',
    region: '华语',
    year: 2023,
    duration: '12:05',
    rating: 9.0,
    views: '890万',
    author: '手作人',
    uploadDate: '2024-06-20',
    updateStatus: '更新至 24 集',
    tags: ['手作', '纪录', '匠心'],
    description: '拜访隐于市井的手艺人，看一件器物如何在双手中慢慢成形。',
    highlights: ['微距工艺特写', '匠人访谈', '慢节奏叙事'],
  },
  {
    id: '1009',
    title: '迷雾谜城',
    cover: 'https://readdy.ai/api/search-image?query=mystery%20thriller%20poster%20of%20a%20foggy%20old%20town%20alley%20with%20a%20single%20street%20lamp%20glow%2C%20peach%20mist%20over%20grey%20stone%20walls%2C%20suspenseful%20cinematic%20composition&width=800&height=450&seq=mvita-cover-1009&orientation=landscape',
    category: '影视',
    categorySlug: 'movie',
    type: '悬疑',
    region: '日韩',
    year: 2024,
    duration: '01:56:00',
    rating: 8.5,
    views: '1,060万',
    author: '迷雾剧场',
    uploadDate: '2024-08-15',
    updateStatus: '全 12 集',
    tags: ['悬疑', '推理', '烧脑'],
    description: '小城接连发生离奇失踪案，一名退休警探重新翻开尘封十年的卷宗。',
    highlights: ['多线推理', '氛围感配乐', '细节彩蛋'],
  },
  {
    id: '1010',
    title: '海底奇观',
    cover: 'https://readdy.ai/api/search-image?query=underwater%20documentary%20poster%20with%20coral%20reef%20and%20rays%20of%20sunlight%20piercing%20turquoise%20water%2C%20subtle%20peach%20highlights%20on%20fish%2C%20serene%20natural%20composition&width=800&height=450&seq=mvita-cover-1010&orientation=landscape',
    category: '影视',
    categorySlug: 'movie',
    type: '纪录片',
    region: '欧美',
    year: 2023,
    duration: '00:52:40',
    rating: 9.2,
    views: '1,320万',
    author: '地球视角',
    uploadDate: '2024-05-28',
    updateStatus: '全 6 集',
    tags: ['纪录片', '海洋', '自然'],
    description: '潜入深海，记录珊瑚礁、深海生物与海洋生态最真实而又震撼的一面。',
    highlights: ['深海探照拍摄', '生物微距', '生态保护主题'],
  },
  {
    id: '1011',
    title: '街头音浪',
    cover: 'https://readdy.ai/api/search-image?query=lively%20street%20music%20live%20cover%20with%20a%20busker%20and%20guitar%20under%20string%20lights%2C%20warm%20peach%20bokeh%20at%20dusk%2C%20energetic%20urban%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=mvita-cover-1011&orientation=landscape',
    category: '直播专区',
    categorySlug: 'live',
    type: '音乐',
    region: '华语',
    year: 2024,
    duration: '直播中',
    rating: 8.7,
    views: '2,180人观看',
    author: '街头音浪',
    uploadDate: '2024-10-11',
    updateStatus: '每周五 19:30 开播',
    tags: ['音乐', '直播', '现场'],
    description: '把舞台搬到街头，让路过的每一个人都成为这场演出的一部分。',
    highlights: ['街头即兴演出', '弹幕点歌', '多机位切换'],
  },
  {
    id: '1012',
    title: '复古时光机',
    cover: 'https://readdy.ai/api/search-image?query=retro%20nostalgia%20short%20video%20cover%20with%20vintage%20film%20camera%2C%20cassette%20tapes%20and%20warm%20peach%20sunlight%20through%20curtains%2C%20cozy%20aesthetic%20flat%20lay%20composition&width=800&height=450&seq=mvita-cover-1012&orientation=landscape',
    category: '短视频',
    categorySlug: 'short',
    type: '创意',
    region: '华语',
    year: 2023,
    duration: '07:30',
    rating: 8.4,
    views: '760万',
    author: '像素工坊',
    uploadDate: '2024-04-16',
    updateStatus: '更新至 40 集',
    tags: ['创意', '怀旧', '剪辑'],
    description: '用剪辑还原记忆里的旧时光，每一帧都藏着上一代人的生活细节。',
    highlights: ['老胶片质感调色', '时代金曲串烧', '创意转场'],
  },
  {
    id: '1013',
    title: '落日旅人',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20film%20poster%20of%20two%20figures%20silhouetted%20on%20a%20coastal%20cliff%20at%20sunset%2C%20warm%20peach%20and%20rose%20sky%2C%20soft%20cinematic%20grading%2C%20emotional%20wide%20composition&width=800&height=450&seq=mvita-cover-1013&orientation=landscape',
    category: '影视',
    categorySlug: 'movie',
    type: '爱情',
    region: '华语',
    year: 2024,
    duration: '01:41:50',
    rating: 8.3,
    views: '1,180万',
    author: '暖光影业',
    uploadDate: '2024-09-08',
    updateStatus: '已完结',
    tags: ['爱情', '治愈', '旅行'],
    description: '两个在旅途中相遇的人，用一段沿海公路的旅程，重新理解了告别。',
    highlights: ['海岸线实景拍摄', '自然光摄影', '原创民谣插曲'],
  },
  {
    id: '1014',
    title: '代码世界',
    cover: 'https://readdy.ai/api/search-image?query=tech%20short%20video%20cover%20with%20glowing%20abstract%20code%20lines%20on%20a%20dark%20screen%2C%20subtle%20peach%20and%20amber%20accents%2C%20futuristic%20minimal%20composition%2C%20clean%20editorial%20design&width=800&height=450&seq=mvita-cover-1014&orientation=landscape',
    category: '短视频',
    categorySlug: 'short',
    type: '科技',
    region: '欧美',
    year: 2024,
    duration: '10:20',
    rating: 8.9,
    views: '980万',
    author: '比特实验室',
    uploadDate: '2024-09-20',
    updateStatus: '更新至 30 集',
    tags: ['科技', '科普', '干货'],
    description: '用最直观的方式拆解前沿技术，让每个人都能看懂代码背后的逻辑。',
    highlights: ['动画可视化讲解', '真实项目案例', '小白友好'],
  },
  {
    id: '1015',
    title: '深夜厨房',
    cover: 'https://readdy.ai/api/search-image?query=late%20night%20kitchen%20live%20cover%20with%20a%20chef%20cooking%20under%20warm%20lamp%20light%2C%20steam%20rising%2C%20peach%20ambient%20glow%2C%20cozy%20intimate%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=mvita-cover-1015&orientation=landscape',
    category: '直播专区',
    categorySlug: 'live',
    type: '美食',
    region: '华语',
    year: 2024,
    duration: '直播中',
    rating: 8.6,
    views: '1,760人观看',
    author: '深夜厨房',
    uploadDate: '2024-10-10',
    updateStatus: '每晚 22:00 开播',
    tags: ['美食', '直播', '治愈'],
    description: '深夜开灶，一边做菜一边聊天，用一顿宵夜抚慰忙碌了一天的你。',
    highlights: ['实时答疑做菜', '深夜连麦', '食材开箱'],
  },
  {
    id: '1016',
    title: '追风骑行',
    cover: 'https://readdy.ai/api/search-image?query=cycling%20documentary%20cover%20of%20a%20cyclist%20on%20a%20winding%20mountain%20road%20at%20golden%20hour%2C%20peach%20haze%20over%20green%20hills%2C%20dynamic%20motion%20editorial%20photography&width=800&height=450&seq=mvita-cover-1016&orientation=landscape',
    category: '影视',
    categorySlug: 'movie',
    type: '运动',
    region: '华语',
    year: 2023,
    duration: '01:12:30',
    rating: 8.8,
    views: '860万',
    author: '追风影像',
    uploadDate: '2024-03-30',
    updateStatus: '全 8 集',
    tags: ['运动', '纪录', '励志'],
    description: '一支业余车队挑战高原骑行，用两个月记录下关于坚持与自由的故事。',
    highlights: ['高原实景骑行', '运动相机视角', '真实训练过程'],
  },
];

export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  tag: string;
  cover: string;
  linkId: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 'hero-1',
    title: '星海旅途',
    subtitle: '跨越星系的孤独远行，用温暖光影讲述人类对未知的向往',
    tag: '本周焦点',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20sci-fi%20scene%20of%20a%20traveler%20before%20a%20vast%20glowing%20nebula%20with%20warm%20peach%20and%20amber%20light%20grading%2C%20abstract%20artistic%20atmosphere%2C%20epic%20film%20composition%2C%20dark%20enough%20for%20text%20overlay&width=1920&height=900&seq=mvita-hero-1&orientation=landscape',
    linkId: '1001',
  },
  {
    id: 'hero-2',
    title: '都市夜行者',
    subtitle: '霓虹未熄的深夜，一桩旧案让城市另一面缓缓浮现',
    tag: '高分悬疑',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20noir%20city%20scene%20at%20night%20with%20neon%20reflections%20on%20wet%20streets%2C%20warm%20peach%20rim%20light%20against%20charcoal%20shadows%2C%20moody%20urban%20atmosphere%2C%20dark%20film%20composition&width=1920&height=900&seq=mvita-hero-2&orientation=landscape',
    linkId: '1002',
  },
  {
    id: 'hero-3',
    title: '山野食光',
    subtitle: '一餐一饭记录季节流转，把生活最本真的滋味端上桌',
    tag: '治愈热播',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20rustic%20countryside%20kitchen%20scene%20with%20fresh%20ingredients%20and%20warm%20morning%20light%2C%20peach%20and%20beige%20tones%2C%20cozy%20natural%20atmosphere%2C%20dark%20vignette%20for%20text%20overlay&width=1920&height=900&seq=mvita-hero-3&orientation=landscape',
    linkId: '1003',
  },
];

export interface TopicCollection {
  id: string;
  title: string;
  desc: string;
  count: number;
  cover: string;
  slug: string;
}

export const topicCollections: TopicCollection[] = [
  {
    id: 'topic-1',
    title: '深夜治愈片单',
    desc: '适合睡前独自观看的温暖故事与慢生活纪录',
    count: 24,
    slug: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20night%20themed%20collection%20cover%20with%20a%20warm%20lamp%2C%20a%20book%20and%20a%20cup%20of%20tea%20by%20a%20window%2C%20peach%20and%20beige%20tones%2C%20calm%20minimal%20editorial%20composition&width=600&height=400&seq=mvita-topic-1&orientation=landscape',
  },
  {
    id: 'topic-2',
    title: '高能悬疑合集',
    desc: '层层反转、细节拉满的推理作品集中营',
    count: 18,
    slug: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=suspense%20collection%20cover%20with%20a%20magnifying%20glass%20over%20old%20documents%2C%20moody%20peach%20side%20light%2C%20mysterious%20dark%20grey%20background%2C%20editorial%20composition&width=600&height=400&seq=mvita-topic-2&orientation=landscape',
  },
  {
    id: 'topic-3',
    title: '短平快精选',
    desc: '通勤路上十分钟就能看完的高质量短视频',
    count: 42,
    slug: 'short',
    cover: 'https://readdy.ai/api/search-image?query=modern%20short%20video%20collection%20cover%20with%20a%20smartphone%20and%20play%20symbol%2C%20bright%20peach%20gradient%20background%2C%20clean%20geometric%20minimal%20design&width=600&height=400&seq=mvita-topic-3&orientation=landscape',
  },
  {
    id: 'topic-4',
    title: '直播间现场',
    desc: '音乐、美食与陪伴，实时互动的热门直播',
    count: 9,
    slug: 'live',
    cover: 'https://readdy.ai/api/search-image?query=live%20streaming%20collection%20cover%20with%20a%20stage%20microphone%20and%20warm%20amber%20spotlight%2C%20peach%20haze%2C%20concert%20atmosphere%2C%20editorial%20composition&width=600&height=400&seq=mvita-topic-4&orientation=landscape',
  },
];